export const ShareIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M10.8333 7.08203H11.25V3.91232C11.25 3.59183 11.5098 3.33203 11.8303 3.33203C11.9916 3.33203 12.1457 3.39922 12.2555 3.51746L17.2165 8.86003C17.3987 9.05629 17.5 9.31421 17.5 9.58203C17.5 9.84985 17.3987 10.1078 17.2165 10.304L12.2555 15.6466C12.1457 15.7648 11.9916 15.832 11.8303 15.832C11.5098 15.832 11.25 15.5722 11.25 15.2517V12.082C6.62129 12.082 4.1224 15.4289 3.49333 16.4026C3.38949 16.5633 3.21427 16.6654 3.02291 16.6654C2.73412 16.6654 2.5 16.4312 2.5 16.1425V15.4154C2.5 10.813 6.23096 7.08203 10.8333 7.08203Z'
      stroke='white'
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
  </svg>
)
